export default Object.freeze({
  CLICK: 0,
  REGISTRATION: 10
})
